export default __webpack_public_path__ + "static/media/ic-changefund@2x.4848e069.png";